import axios from 'axios';
import { backendUrl } from '../config/axiosInstance';

const token = localStorage.getItem("admintoken");

// Get all happy customers
export const getAllHappyCustomers = async () => {
    try {
        const response = await axios.get(`${backendUrl}/api/user/happy-customer/get-happy-customers`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching happy customers:', error);
        throw error;
    }
};

// Get single happy customer by ID
export const getHappyCustomerById = async (id) => {
    try {
        const response = await axios.get(`${backendUrl}/api/user/happy-customer/get-happy-customer/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching happy customer:', error);
        throw error;
    }
};

// Create happy customer with images
export const createHappyCustomer = async (formData) => {
    try {
        const response = await axios.post(`${backendUrl}/api/user/happy-customer/create-happy-customer`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating happy customer:', error);
        throw error;
    }
};

// Update happy customer
export const updateHappyCustomer = async (id, formData) => {
    try {
        const response = await axios.put(`${backendUrl}/api/user/happy-customer/update-happy-customer/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating happy customer:', error);
        throw error;
    }
};

// Delete happy customer
export const deleteHappyCustomer = async (id) => {
    try {
        const response = await axios.delete(`${backendUrl}/api/user/happy-customer/delete-happy-customer/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting happy customer:', error);
        throw error;
    }
};
